import { render, staticRenderFns } from "./PolicySelectionCheckboxes.vue?vue&type=template&id=71e1d90c&scoped=true&"
import script from "./PolicySelectionCheckboxes.vue?vue&type=script&lang=js&"
export * from "./PolicySelectionCheckboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e1d90c",
  null
  
)

export default component.exports